/**
 * Buy Together cart helper. Quantity math matches backend/src/lib/buy-together-qty.js.
 * Opens the existing Canopy cart-drawer. No apps, no external CDN, no bundle pricing.
 */
(function () {
  if (window.BobaBuyTogetherInit) return;
  window.BobaBuyTogetherInit = true;

  function parseMoqNumber(value, fallback) {
    if (value == null || value === '') return fallback;
    var n = Number(value);
    return Number.isFinite(n) ? n : fallback;
  }

  function ceilToIncrement(quantity, increment) {
    var qty = Math.max(0, Math.floor(Number(quantity) || 0));
    var step = Math.max(1, Math.floor(parseMoqNumber(increment, 1)));
    if (qty === 0) return 0;
    return Math.ceil(qty / step) * step;
  }

  function buyTogetherBaseQty(moqMin, moqIncrement) {
    var min = Math.max(1, Math.floor(parseMoqNumber(moqMin, 1)));
    var increment = Math.max(1, Math.floor(parseMoqNumber(moqIncrement, 1)));
    return ceilToIncrement(min, increment);
  }

  function buyTogetherAddQty(existingQty, moqMin, moqIncrement) {
    var increment = Math.max(1, Math.floor(parseMoqNumber(moqIncrement, 1)));
    var baseQty = buyTogetherBaseQty(moqMin, moqIncrement);
    var existing = Math.max(0, Math.floor(Number(existingQty) || 0));
    var compliantAfter = ceilToIncrement(existing + baseQty, increment);
    return Math.max(0, compliantAfter - existing);
  }

  function cartQtyByVariantId(cart, variantId) {
    var id = Number(variantId);
    if (!Number.isFinite(id) || id <= 0) return 0;
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    return items.reduce(function (sum, item) {
      var itemId = Number(item.variant_id || item.id);
      if (itemId !== id) return sum;
      return sum + Math.max(0, Math.floor(Number(item.quantity) || 0));
    }, 0);
  }

  function moneyFromCents(cents) {
    var amount = Math.max(0, Math.round(Number(cents) || 0));
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      var format = (window.theme && theme.moneyFormat) || Shopify.money_format || '£{{amount}}';
      return Shopify.formatMoney(amount, format);
    }
    return '£' + (amount / 100).toFixed(2);
  }

  function routes() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (window.theme && theme.routes) {
      return {
        cartJs: (theme.routes.cart || (root + 'cart')) + '.js',
        cartAdd: theme.routes.cartAdd || (root + 'cart/add.js'),
      };
    }
    return { cartJs: root + 'cart.js', cartAdd: root + 'cart/add.js' };
  }

  // Disabled means locked, not unselected. Primary is checked+disabled in Liquid.
  // Keep in lockstep with backend/src/lib/buy-together-qty.js isBuyTogetherItemSelected.
  function isItemSelected(check, available, role) {
    if (!check || !available || !check.checked) return false;
    if (role === 'primary') return true;
    return !check.disabled;
  }

  function itemState(row) {
    var check = row.querySelector('[data-buy-together-check]');
    var available = row.getAttribute('data-available') !== 'false';
    var role = row.getAttribute('data-role') || 'companion';
    var selected = isItemSelected(check, available, role);
    return {
      row: row,
      role: role,
      title: row.getAttribute('data-title') || 'This item',
      sku: row.getAttribute('data-sku') || '',
      variantId: Number(row.getAttribute('data-variant-id')),
      priceCents: Number(row.getAttribute('data-price-cents')) || 0,
      moqMin: row.getAttribute('data-moq-min'),
      moqIncrement: row.getAttribute('data-moq-increment'),
      available: available,
      selected: selected,
      qty: buyTogetherBaseQty(row.getAttribute('data-moq-min'), row.getAttribute('data-moq-increment')),
    };
  }

  function selectedItems(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-buy-together-item]'))
      .map(itemState)
      .filter(function (item) { return item.selected && item.variantId > 0; });
  }

  function renderTotals(root) {
    var totalCents = 0;
    Array.prototype.forEach.call(root.querySelectorAll('[data-buy-together-item]'), function (row) {
      var item = itemState(row);
      var qtyEl = row.querySelector('[data-buy-together-qty]');
      var lineEl = row.querySelector('[data-buy-together-line]');
      if (qtyEl) qtyEl.textContent = 'Qty ' + item.qty;
      var lineCents = item.selected ? item.priceCents * item.qty : 0;
      if (lineEl) lineEl.textContent = moneyFromCents(item.available ? item.priceCents * item.qty : item.priceCents);
      if (item.selected) totalCents += lineCents;
    });
    var totalEl = root.querySelector('[data-buy-together-total]');
    if (totalEl) totalEl.textContent = moneyFromCents(totalCents);
  }

  function setError(root, message) {
    var el = root.querySelector('[data-buy-together-error]');
    if (!el) return;
    if (!message) {
      el.hidden = true;
      el.textContent = '';
      return;
    }
    el.hidden = false;
    el.textContent = message;
  }

  function identifyFailedItem(items, payload) {
    var text = [payload && payload.description, payload && payload.message]
      .concat(payload && payload.errors ? JSON.stringify(payload.errors) : [])
      .filter(Boolean)
      .join(' ');
    var match = items.find(function (item) {
      return (item.title && text.indexOf(item.title) !== -1) || (item.sku && text.indexOf(item.sku) !== -1);
    });
    return match || null;
  }

  function formatAddError(items, payload, fallback) {
    var apiText = (payload && (payload.description || payload.message)) || fallback || 'Could not add the selected items to cart.';
    if (typeof apiText !== 'string') apiText = JSON.stringify(apiText);
    var failed = identifyFailedItem(items, payload || {});
    var names = items.map(function (item) { return item.title + ' (qty ' + item.addQty + ')'; }).join('; ');
    if (failed) {
      return 'Could not add ' + failed.title + ': ' + apiText;
    }
    return 'Could not add these items: ' + names + '. ' + apiText;
  }

  function drawerSectionId() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return null;
    var section = drawer.closest('.shopify-section');
    if (!section || !section.id) return null;
    return section.id.replace('shopify-section-', '');
  }

  function openExistingCartDrawer(addPayload) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && addPayload && addPayload.sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents(addPayload, true);
      return;
    }
    if (drawer && typeof drawer.refreshCartDrawer === 'function') {
      Promise.resolve(drawer.refreshCartDrawer()).then(function () {
        if (typeof drawer.open === 'function') drawer.open();
      });
      return;
    }
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
  }

  function relocate(root) {
    if (root.getAttribute('data-relocate') === 'false') return;
    if (root.getAttribute('data-relocated') === 'true') return;
    var host = document.querySelector('.cc-main-product .product-info product-form');
    if (!host) host = document.querySelector('.product-main .product-info product-form');
    if (!host) return;
    host.after(root);
    root.setAttribute('data-relocated', 'true');
  }

  async function addSelected(root, button) {
    var items = selectedItems(root);
    setError(root, '');
    if (!items.length) {
      setError(root, 'Select at least one available item.');
      return;
    }

    var missingVariant = items.find(function (item) { return !item.variantId; });
    if (missingVariant) {
      setError(root, 'Could not add ' + missingVariant.title + ': no sellable variant.');
      return;
    }

    button.disabled = true;
    try {
      var path = routes();
      var cartRes = await fetch(path.cartJs, { headers: { Accept: 'application/json' } });
      if (!cartRes.ok) throw new Error('Could not read the current cart.');
      var cart = await cartRes.json();

      var payloadItems = items.map(function (item) {
        var addQty = buyTogetherAddQty(
          cartQtyByVariantId(cart, item.variantId),
          item.moqMin,
          item.moqIncrement
        );
        item.addQty = addQty;
        return { id: item.variantId, quantity: addQty };
      }).filter(function (row) { return row.quantity > 0; });

      if (!payloadItems.length) {
        openExistingCartDrawer();
        return;
      }

      var sectionId = drawerSectionId();
      var body = {
        items: payloadItems,
        sections: sectionId ? ('cart-icon-bubble,' + sectionId) : 'cart-icon-bubble',
        sections_url: window.location.pathname,
      };

      var addRes = await fetch(path.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      var addJson = await addRes.json().catch(function () { return {}; });
      if (!addRes.ok || addJson.status) {
        throw new Error(formatAddError(items, addJson, addRes.statusText));
      }

      document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { items: payloadItems } }));
      openExistingCartDrawer(addJson);
    } catch (error) {
      setError(root, error && error.message ? error.message : 'Could not add the selected items to cart.');
    } finally {
      button.disabled = false;
    }
  }

  function bind(root) {
    if (root.getAttribute('data-buy-together-bound') === 'true') return;
    root.setAttribute('data-buy-together-bound', 'true');
    relocate(root);
    renderTotals(root);

    root.addEventListener('change', function (event) {
      if (!event.target.closest('[data-buy-together-check]')) return;
      var row = event.target.closest('[data-buy-together-item]');
      if (row && row.getAttribute('data-role') === 'primary') {
        event.target.checked = true;
      }
      renderTotals(root);
    });

    var cta = root.querySelector('[data-buy-together-cta]');
    if (cta) {
      cta.addEventListener('click', function () { addSelected(root, cta); });
    }
  }

  function bindAll() {
    document.querySelectorAll('[data-buy-together]').forEach(bind);
  }

  document.addEventListener('on:variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || !variant.id) return;
    document.querySelectorAll('[data-buy-together-item][data-role="primary"]').forEach(function (row) {
      row.setAttribute('data-variant-id', String(variant.id));
      if (variant.price != null) row.setAttribute('data-price-cents', String(variant.price));
      var root = row.closest('[data-buy-together]');
      if (root) renderTotals(root);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
})();
